import { gql } from "graphql-tag";

const GET_STOCK_LIST = gql`
  query GetStocks {
    stock {
      id
      company_name
    }
  }
`;
const GET_USER_MF_PORTFOLIO = gql`
  query GetUserMFPortfolio($email: String!) {
    portfolio_mutual_funds(where: { user: { email: { _eq: $email } } }) {
      mutual_fund {
        id
        name
        return_3Y
        star_rating
        isDipSipETF
      }
    }
    users(where: { email: { _eq: $email } }) {
      user_configs {
        key
        value
      }
    }
  }
`;
const INSERT_USER_MF_PORTFOLIO = gql`
  mutation InsertMFPortfolio($object: portfolio_mutual_funds_insert_input!) {
    insert_portfolio_mutual_funds_one(object: $object) {
      mutual_fund_id
      user_id
    }
  }
`;

const DELETE_USER_MF_PORTFOLIO = gql`
  mutation deleteUserMutualFundPortfolio(
    $mutual_fund_id: Int!
    $email: String!
  ) {
    delete_portfolio_mutual_funds(
      where: {
        mutual_fund_id: { _eq: $mutual_fund_id }
        user: { email: { _eq: $email } }
      }
    ) {
      affected_rows
    }
  }
`;
const GET_USER_WATCH_LIST = gql`
  query GetUserStockPortfolio($email: String!) {
    watch_list(where: { user: { email: { _eq: $email } } }) {
      company_profile {
        id
        company_name: companyName
      }
    }
  }
`;
const INSERT_WATCHLIST_INSTRUMENT = gql`
  mutation addInstrumentToWatchList($object: watch_list_insert_input!) {
    insert_watch_list_one(object: $object) {
      user_id
      company_id
      market_index_id
    }
  }
`;
const DELETE_WATCHLIST_INSTRUMENT = gql`
  mutation deleteInstrumentToWatchList(
    $company_id: Int!
    $email: String!
    $instrument_type: Int!
  ) {
    delete_watch_list(
      where: {
        instrument_type: { _eq: $instrument_type }
        company_id: { _eq: $company_id }
        user: { email: { _eq: $email } }
      }
    ) {
      affected_rows
    }
  }
`;
const GET_USER_ID_FROM_EMAIL = gql`
  query GetUserIdFromEmail($email: String!) {
    users(where: { email: { _eq: $email } }) {
      id
    }
  }
`;

const GET_USER_CONFIG = gql`
  query GetUserConfig($email: String!) {
    user_config(where: { user: { email: { _eq: $email } } }) {
      key
      value
      user_id
    }
  }
`;
const INSERT_USER_CONFIG = gql`
  mutation insertUserConfig($object: user_config_insert_input!) {
    insert_user_config_one(
      object: $object
      on_conflict: {
        constraint: user_config_user_id_key_key
        update_columns: [value]
      }
    ) {
      id
    }
  }
`;
const INSERT_USER_FEEDBACK = gql`
  mutation InsertUserFeedback($object: user_feedback_insert_input!) {
    insert_user_feedback_one(object: $object) {
      user_id
    }
  }
`;
const DELETE_USER_CONFIG = gql`
  mutation deleteUserConfig($email: String!, $key: String!) {
    delete_user_config(
      where: { key: { _eq: $key }, user: { email: { _eq: $email } } }
    ) {
      affected_rows
    }
  }
`;

const UPDATE_TELEGRAM_ID_BY_EMAIL = gql`
  mutation UpdateTelegramId($email: String!, $telegram_id: bigint!) {
    update_users(
      where: { email: { _eq: $email } }
      _set: { telegram_id: $telegram_id }
    ) {
      affected_rows
    }
  }
`;

const INSERT_USER_INSTRUMENT = gql`
  mutation InsertUserInstrument(
    $instrument_token: Int
    $notification_frequency: Int
    $user_id: Int
    $value: Int
    $allocation_factor: numeric
    $base_amount: numeric
    $trigger: numeric
    $notification_frequency_unit: interval_enum
  ) {
    insert_user_instrument(
      objects: {
        instrument_token: $instrument_token
        notification_frequency: $notification_frequency
        user_id: $user_id
        value: $value
        allocation_factor: $allocation_factor
        base_amount: $base_amount
        trigger: $trigger
        notification_frequency_unit: $notification_frequency_unit
      }
    ) {
      affected_rows
      returning {
        id
        instrument_token
        notification_frequency
        user_id
        value
        allocation_factor
        base_amount
        trigger
        notification_frequency_unit
      }
    }
  }
`;

const UPSERT_USER_INSTRUMENT = gql`
  mutation UpsertUserInstrument($objects: [user_instrument_insert_input!]!) {
    insert_user_instrument(
      objects: $objects
      on_conflict: {
        constraint: user_instrument_user_id_instrument_symbol_key
        update_columns: [
          notification_frequency
          value
          allocation_factor
          base_amount
          trigger
          notification_frequency_unit
        ]
      }
    ) {
      affected_rows
      returning {
        id
        user_id
        instrument_symbol
        instrument_token
        value
      }
    }
  }
`;

const DELETE_USER_INSTRUMENT = gql`
  mutation DeleteSelectedUserInstruments(
    $user_id: Int!
    $instrumentTokens: [Int!]!
  ) {
    delete_user_instrument(
      where: {
        user_id: { _eq: $user_id }
        instrument_token: { _in: $instrumentTokens }
      }
    ) {
      affected_rows
    }
  }
`;

const GET_USER_INSTRUMENTS = gql`
  query GetUserInstruments($user_id: Int!) {
    user_instrument(where: { user_id: { _eq: $user_id } }) {
      id
      user_id
      instrument_symbol
      instrument_token
      value
      base_amount
      trigger
      notification_frequency
      notification_frequency_unit
      allocation_factor
    }
  }
`;

const GET_PORTFOLIO_ANNOUNCEMENTS = gql`
  query UserStockPortfolio(
    $email: String!
    $fromDate: date!
    $toDate: date!
    $fromDateTime: timestamptz!
    $toDateTime: timestamptz!
  ) {
    watch_list(where: { user: { email: { _eq: $email } } }) {
      company_profile {
        company_name: companyName
        stock_announcements: company_announcements(
          where: {
            announcement_sentiment: { _gt: -1 }
            announcement_date: { _gte: $fromDate, _lte: $toDate }
          }
        ) {
          announcement_date
          announcement_text_summary
          announcement_impact
          announcement_document_link
          announcement_sentiment
        }
        insider_trades: company_insider_trades(
          where: { created_at: { _gte: $fromDateTime, _lte: $toDateTime } }
        ) {
          intimation_date
          name_of_insider
          number_of_securities_transacted
          number_of_securities_after_transaction
          number_of_securities_before_transaction
          type_of_security
          shareholding_before_transaction
          shareholding_after_transaction
          mode_of_transaction
          transaction_type
          category_of_insider
        }
      }
    }
  }
`;
const USER_CHAT_HISTORY = gql`
  query UserChatHistory($email: String!) {
    user_chat(
      order_by: { id: desc }
      where: { is_first: { _eq: true }, user: { email: { _eq: $email } } }
    ) {
      id
      chat_uuid
      chat_title
      text_content_user_query
      text_content_assistant_formatted_response
      created_at
      updated_at
      is_alert_set
    }
  }
`;
const USER_CHAT_MESSAGES_FOR_ID = gql`
  query UserChatHistory($email: String!, $chat_uuid: uuid!) {
    user_chat(
      order_by: { id: asc }
      where: {
        chat_uuid: { _eq: $chat_uuid }
        user: { email: { _eq: $email } }
      }
    ) {
      id
      chat_uuid
      chat_title
      text_content_user_query
      text_content_assistant_formatted_response
      created_at
      updated_at
      is_alert_set
    }
  }
`;

const CHAT_VIEW = gql`
  query UserChatHistory($chat_uuid: uuid!) {
    user_chat(
      where: { chat_uuid: { _eq: $chat_uuid } }
      order_by: { updated_at: asc }
    ) {
      chat_uuid
      chat_title
      text_content_user_query
      text_content_assistant_formatted_response
      created_at
      updated_at
    }
  }
`;
const SAVE_USER_CHAT = gql`
  mutation SAVE_USER_CHAT(
    $chat_title: String!
    $chat_id: Int!
    $chat_uuid: uuid!
    $is_alert_set: Boolean!
  ) {
    update_user_chat(
      _set: { chat_title: $chat_title, is_alert_set: $is_alert_set }
      where: { id: { _eq: $chat_id }, chat_uuid: { _eq: $chat_uuid } }
    ) {
      returning {
        id
      }
    }
  }
`;
const UNSAVE_USER_CHAT = gql`
  mutation UNSAVE_USER_CHAT(
    $chat_id: Int!
    $chat_uuid: uuid!
    $is_alert_set: Boolean!
  ) {
    update_user_chat(
      _set: { is_alert_set: $is_alert_set }
      where: { id: { _eq: $chat_id }, chat_uuid: { _eq: $chat_uuid } }
    ) {
      returning {
        id
      }
    }
  }
`;
const USER_SAVED_PROMPTS = gql`
  query UserSavedPrompts($email: String!) {
    user_chat(
      order_by: { id: desc }
      where: { is_alert_set: { _eq: TRUE }, user: { email: { _eq: $email } } }
    ) {
      id
      chat_uuid
      chat_title
      text_content_user_query
    }
  }
`;
const GET_INDEXES = gql`
  query GetIndexes {
    market_indices(
      where: {
        market_index_wise_companies: { company_id: { _is_null: false } }
      }
    ) {
      index_name
    }
  }
`;
const GET_COMPANIES_FOR_INDEX = gql`
  query GetCompaniesForIndex($index_name: String!) {
    market_index_wise_companies(
      where: { market_index: { index_name: { _eq: $index_name } } }
    ) {
      company_profile {
        companyName
        marketCap
        industry
        kite_instrument_token
        sector
        stock_price_volume_daily_moving_average {
          price_dma_5_day
          price_dma_10_day
          price_dma_20_day
          price_dma_50_day
          price_dma_100_day
          price_dma_200_day

          volume_dma_5_day
          volume_dma_10_day
          volume_dma_20_day
          volume_dma_50_day
          volume_dma_100_day
          volume_dma_200_day
        }
      }
    }
  }
`;
const GET_ENUM_ASSET_TYPE = gql`
  query {
    gql_enum_asset_type {
      name
    }
  }
`;
const GET_ENUM_INTERVAL = gql`
  query {
    gql_enum_interval {
      name
    }
  }
`;
export {
  GET_STOCK_LIST,
  INSERT_WATCHLIST_INSTRUMENT,
  GET_USER_WATCH_LIST,
  DELETE_WATCHLIST_INSTRUMENT,
  GET_PORTFOLIO_ANNOUNCEMENTS,
  GET_USER_MF_PORTFOLIO,
  INSERT_USER_MF_PORTFOLIO,
  DELETE_USER_MF_PORTFOLIO,
  GET_USER_CONFIG,
  GET_USER_ID_FROM_EMAIL,
  INSERT_USER_CONFIG,
  DELETE_USER_CONFIG,
  UPDATE_TELEGRAM_ID_BY_EMAIL,
  INSERT_USER_INSTRUMENT,
  UPSERT_USER_INSTRUMENT,
  DELETE_USER_INSTRUMENT,
  GET_USER_INSTRUMENTS,
  USER_CHAT_HISTORY,
  CHAT_VIEW,
  SAVE_USER_CHAT,
  UNSAVE_USER_CHAT,
  USER_CHAT_MESSAGES_FOR_ID,
  USER_SAVED_PROMPTS,
  INSERT_USER_FEEDBACK,
  GET_INDEXES,
  GET_COMPANIES_FOR_INDEX,
  GET_ENUM_ASSET_TYPE,
  GET_ENUM_INTERVAL,
};
